<template>
  <header class='lt-fyf-header'>
    <div :class="['lt-fyf-header_content', isOnWelcomePage ? 'lt-fyf-header_content--welcome' : '']">
      <slot>
        <img
          class='lt-logo'
          src="../assets/logo.svg"
          alt="COMPANY NAME"
        />
      </slot>
      <div class="lt-fyf-button-container">
        <button
          :class="['lt-fyf-toggle-scene', showForeground ? 'lt-fyf-toggle-scene--active' : '']"
          @click="showForeground = !showForeground"
          v-show='showToggleSceneButton'
          aria-hidden="true"
        >
          <p>Toggle scene</p>
        </button>
      </div>
    </div>
  </header>
</template>


<script>
import { mapGetters, mapState } from 'vuex';
import { mapFields } from "vuex-map-fields";

export default {
  data () {
    return {
    };
  },
  computed: {
    ...mapFields([
      'ui.showForeground',
      'ui.isAnimating',
    ]),
    ...mapGetters([
      'isOnPage',
      'currentPage',
    ]),
    isOnWelcomePage: function () {
      return this.isOnPage('welcome');
    },
    showToggleSceneButton: function () {
      const pagesHiddenOn = ['welcome', 'loading'];
      const isOnHiddenPage = _.includes(pagesHiddenOn, this.currentPage);

      return this.isAnimating === false && isOnHiddenPage === false;
    },
  },
};
</script>

<style lang='scss'>

.lt-fyf-header {
  display: flex;
  justify-content: center;
}

.lt-fyf-header_content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: max-width .5s ease-out;
  width: 100%;
  max-width: 100%;

  &.lt-fyf-header_content--welcome {
    max-width: 720px;
  }
}

.lt-fyf-button-container {
  position: relative;
}

button.lt-fyf-toggle-scene {
  appearance: none;
  background: $toggle-scene-button-background-color url('../assets/edit-solid.svg') no-repeat center center;
  box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.5);
  background-size: 60%;
  width: 40px;
  height: 40px;
  color: white;
  border-radius: 100%;
  border: 0 none;
  cursor: pointer;
  z-index: 60;
  outline: 0;
  p {
    position: absolute;
    margin: 1.5rem 0 0;
    width: 5rem;
    font-weight: bold;
    transform: translateX(-36%);
    @media (max-width: 500px) {
      display: none;
    }
  }

  &.lt-fyf-toggle-scene--active {
    background-image: url('../assets/image-solid.svg');
  }
}
</style>
